export type PostCategory =
    | "All"
    | "Jobs"
    | "Events"
    | "Volunteering"
    | "Services"
    | "Marketplace"
    | "MAX Initiatives"
    | "Cities"
    | "General";

export const POST_CATEGORIES: PostCategory[] = [
    "All",
    "Jobs",
    "Events",
    "Volunteering",
    "Services",
    "Marketplace",
    "MAX Initiatives",
    "Cities",
    "General",
];

export const CATEGORY_DESCRIPTIONS: Record<PostCategory, string> = {
    All: "All posts and updates",
    Jobs: "Career opportunities, internships, and job openings",
    Events: "Upcoming events, workshops, webinars, and meetups",
    Volunteering: "Volunteer roles and community support requests",
    Services: "Offers, requests, or recommendations for services",
    Marketplace: "Buy, sell, or trade items, services, or experiences",
    "MAX Initiatives": "Updates and news from official MAX programs",
    Cities: "Local posts from specific cities or MAX communities",
    General: "Miscellaneous updates that don't fit other categories",
};
